// src/components/cookie-consent/config.tracking.ts
'use client'

// Get current environment - this will be sent with all tracking events
// We need to use NEXT_PUBLIC_ prefix for client-side access
// Priority: NEXT_PUBLIC_APP_ENV > NODE_ENV > 'development'
const currentEnvironment = process.env.NEXT_PUBLIC_APP_ENV || process.env.NODE_ENV || 'development';
const isProduction = currentEnvironment === 'production';
const isDevelopment = currentEnvironment === 'development';
const isLocal = currentEnvironment === 'local';

// Debug flag for GTM logging - set to false to disable GTM console logs
const GTM_DEBUG_ENABLED = false;

// GTM IDs for different environments
const GTM_TAG_IDS = {
    production: 'GT-P8RT8ZS4',
    development: 'GT-NCHVSWWM',
    local: 'GT-NCHVSWWM'
};

// Determine which GTM Tag ID to use based on environment
const getGtmTagId = () => {
    // First check if explicitly set in environment
    if (process.env.NEXT_PUBLIC_GTM_TAG_ID) {
        return process.env.NEXT_PUBLIC_GTM_TAG_ID;
    }
    // Otherwise use environment-specific default
    return GTM_TAG_IDS[currentEnvironment as keyof typeof GTM_TAG_IDS] || GTM_TAG_IDS.development;
};

// Check if GTM is properly configured
export const IS_GTM_ENABLED =
    process.env.NEXT_PUBLIC_GTM_TAG_ID !== undefined &&
    process.env.NEXT_PUBLIC_GTM_TAG_ID !== '' &&
    process.env.NEXT_PUBLIC_SERVER_CONTAINER_HOSTNAME !== undefined;

// Log tracking configuration on initialization (only in non-production)
if (typeof window !== 'undefined' && !isProduction && GTM_DEBUG_ENABLED) {
    // console.log('🔧 [GTM Config] Tracking Configuration:', {
// //     enabled: IS_GTM_ENABLED,
// //     environment: currentEnvironment,
// //     gtmTagId: getGtmTagId(),
// //     serverHost: process.env.NEXT_PUBLIC_SERVER_CONTAINER_HOSTNAME,
// //     gtmContainerId: process.env.NEXT_PUBLIC_GTM_CONTAINER_ID,
// //     ga4MeasurementId: process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID,
// //     timestamp: new Date().toISOString()
    // });

    if (!IS_GTM_ENABLED) {
        console.warn('⚠️ [GTM Config] GTM is not properly configured. Missing GTM_TAG_ID or SERVER_CONTAINER_HOSTNAME');
    }
}

export const trackingConfig = {
    gtmContainerId: process.env.NEXT_PUBLIC_GTM_CONTAINER_ID || 'GTM-KGSCRJ9G', // GTM Web Container ID
    ga4MeasurementId: process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID || '', // GA4 Measurement ID for reference
    gtmTagId: getGtmTagId(), // Environment-specific GTM Tag ID
    serverContainerHostname: process.env.NEXT_PUBLIC_SERVER_CONTAINER_HOSTNAME || 'gtm.moebelguru.de', // GTM server domain
    cookieBannerCookieName: 'cookieConsent',
    environment: currentEnvironment, // This will be sent with all tracking events
    isProduction,
    isDevelopment,
    isLocal,
    // Debug mode for non-production environments
    debugMode: !isProduction,
    // Tracking version for debugging
    trackingVersion: '3.0'
};
